import { useNavigate } from "react-router-dom";
import { Articles } from "../../data/models/article";
import Routes from "router/routes";

const RelatedArticlesItem = ({ article }: { article: Articles }) => {
  const navigate = useNavigate();

  return (
    <div
      key={article.id}
      className="flex h-full cursor-pointer flex-col rounded-[20px] lg:w-[427px]"
      onClick={() => {
        navigate(Routes.BLOG_POST(article.slug), {
          state: article,
        });
      }}
    >
      <img
        src={`${process.env.REACT_APP_STRAPI_URL}${article.cover?.formats.large.url}`}
        alt={article.title}
        className="h-[265px] w-full rounded-[16px] object-cover"
      />

      <div className="mt-8 flex flex-col">
        <p className="font-inter text-[24px] font-bold text-[#131313]">
          {article.title}
        </p>
        <p className="mb-6 line-clamp-3 font-inter text-[18px] text-[#5A5A59]">
          {article.description}
        </p>
        {/* <div className="mt-auto flex items-center justify-between">
          <p className="font-inter text-[16px] text-[#5A5A59]">
            By {article.author}
          </p>
          <p className="font-inter text-[16px] text-[#5A5A59]">
            {formatDate(article.createdAt ?? "")}
          </p>
        </div> */}
      </div>
    </div>
  );
};

export default RelatedArticlesItem;
